import React, {createContext, useEffect, useState} from 'react';
import {setDatadogUser} from "../util/datadog";
import useFetch from "../hooks/useFetch";
import {Apis} from "../util/Apis";
import {useNavigate} from "react-router";
import axios from "axios";
import { getCurrencyConfig, syncSalaCurrencyConfig } from "../components/services";

export const SiteContext = createContext({
  salaId: null,
  setSalaId: () => {},
  info: {},
  setInfo: () => {},
  sorteosConf: null,
  setSorteosConf: () => {},
  currencyConfig: getCurrencyConfig(),
  setCurrencyConfig: () => {},
  // Las vistas públicas (el ranking público) usan ContainerBackgroundWrapper fuera de SiteProvider.
  ads: [],
});

export const SiteProvider = (props) => {

  //TODO, sala y salaId podrian guardarse en un solo item de local storage, es necesario guardarlo al hacer refresh se pierde el contexto
  //TODO, moreInfo debe tener toda la data necesaria para guardarla en memoria, hacer query on refresh
  // La sala elegida vive en localStorage para no perderla al recargar.
  const [salaId, setSalaId] = useState(() => localStorage.getItem('salaId'))
  const [info, setInfo] = useState(() => localStorage.getItem('salaId') === null ? {} : {sala: JSON.parse(localStorage.getItem('sala'))})
  const [ads, setAds] = useState([])
  const [currencyConfig, setCurrencyConfig] = useState(getCurrencyConfig)

  const {loading, data} = useFetch(Apis.USER + '/users/me?product=gaming', null)
  const {data: sorteosConfData} = useFetch(Apis.SORTEOS + '/sorteo-conf')
  const navigate = useNavigate()

  // La configuración de sorteos llega del servidor, pero IdlePage también la actualiza: se pisa solo cuando llegan
  // datos nuevos del servidor.
  const [sorteosConf, setSorteosConf] = useState(sorteosConfData);
  const [loadedSorteosConf, setLoadedSorteosConf] = useState(sorteosConfData);
  if (sorteosConfData !== loadedSorteosConf) {
    setLoadedSorteosConf(sorteosConfData)
    setSorteosConf(sorteosConfData)
  }

  useEffect(() => {
    const salaId = localStorage.getItem('salaId')

    if(salaId === undefined || salaId === null){
      navigate("/selector")
      return
    }

    syncSalaCurrencyConfig(salaId, getCurrencyConfig()).then((config) => {
      setCurrencyConfig(config)
    })

    axios.get(Apis.PC + '/ads-banners/active').then(res => {
      setAds(res.data)
    }).catch(() => {})
    // Solo al montar: history es estable en react-router 5.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if(data && data.user !== undefined){
      setDatadogUser({
        //id: '1234',
        name: data.user.name
      })
    }
  }, [data])

  return (
    <SiteContext.Provider value={{salaId, setSalaId, info, setInfo, ads, sorteosConf, setSorteosConf, currencyConfig, setCurrencyConfig}}>
      {
        loading ?
          <div>Cargando...</div> :
          props.children
      }
    </SiteContext.Provider>
  );
}
